import { connect } from "react-redux";
import LoginClaveUnica from './LoginClaveUnica';
import { userSignIn } from '../../redux/actions/auth'

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};


const mapDispatchToProps = dispatch => {
  return {
    userLoggedIn: user => {      
      dispatch(userSignIn(user));
    }
  };
};

export default connect(
    mapStatetoProps,
    mapDispatchToProps
  )(LoginClaveUnica);
  